
export default {
	props: {
		grid: {
			type: Boolean,
			default: false,
		},
		standOut: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				'card--has-addition-info': this.$slots.additional,
				'card--grid': this.grid,
				'card--stand-out': this.standOut,
			}
		},
	},
}
